import AppsContainer from "../../components/UmmIACategories/AppsContainer";
import HeaderCategoria from "../../components/UmmIACategories/HeaderCategoria";
import UmmIAPediaTitleImg from "../../components/UmmIACategories/img/UmmIAPediaTitleImg.png";

const UmmIAPediaPage = () => {
  return (
    <>
      {/* Contenedor de cabecera */}
      <HeaderCategoria
        titulo="UmmIAPedia"
        descripcion="Aplicaciones para fortalecer tu desarrollo profesional"
        img={UmmIAPediaTitleImg}
        alt="Imagen UmmIA Pedia"
        primaryColor="#8B3355"
        secondaryColor="#E8D6DD"
        thirdColor="#A25C77"
        backButton="#FFFFFF"
        secondPercentage="50"
      />

      {/* Contenedor de tarjetas: se renderizan solo las apps a las que el usuario tiene acceso */}
      <AppsContainer filter="UmmIAPedia" />
    </>
  );
};

export default UmmIAPediaPage;
